import React, { useEffect } from 'react'
import HourButton from './HourButton'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_TIME_SLOTS } from '../redux/timeSlotsReducer'
import { RootReducer } from '../redux/rootReducer'
import { CREATE_TIME_SLOT } from '../redux/timeSlotsReducer'
const Hours = () => {
  const dispatch = useDispatch()
  const selectedDay = useSelector((state: RootReducer) => state.timeSlotsReducer.selectedDay)
  const selectedDaySlots = useSelector((state: RootReducer) => {
    const tutorsTimeSlots = state.timeSlotsReducer.timeSlots
    const startOfDay = new Date(selectedDay.year, selectedDay.month, parseInt(selectedDay.day)).getTime() / 1000
    const endOfDay = startOfDay + 24 * 60 * 60
    return tutorsTimeSlots.filter((slot) => {
      return slot.start >= startOfDay && slot.start < endOfDay
    })
  })

  useEffect(() => {
    dispatch(FETCH_TIME_SLOTS())
  }, [dispatch])

  if (!selectedDay.day) {
    return null
  }

  return (
    <div>
      <div className="flex justify-center items-center flex-wrap gap-2">
        {[...Array(48)].map((_, index) => {
          const hour = Math.floor(index / 2)
          const minute = (index % 2) * 30
          const timestamp =
            new Date(selectedDay.year, selectedDay.month, parseInt(selectedDay.day), hour, minute).getTime() / 1000
          const now = Math.floor(Date.now() / 1000)
          if (timestamp < now) {
            return null
          }
          const isAvailable = selectedDaySlots.find((slot) => slot.start === timestamp)?.is_available || false
          return (
            <HourButton
              key={index}
              active={isAvailable}
              onClick={() => dispatch(CREATE_TIME_SLOT({ start_time: timestamp, is_available: !isAvailable }))}>
              {new Date(timestamp * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </HourButton>
          )
        })}
      </div>
    </div>
  )
}

export default Hours
